import Alpine from 'alpinejs';
import focus from '@alpinejs/focus';
import lightbox from 'alpine-tailwind-lightbox';

Alpine.plugin(focus);
Alpine.plugin(lightbox);

Alpine.data('lightbox', () => ({
  init() {
    this.$refs.proseContainer.querySelectorAll('figure.attachment> a').forEach((element) => {
      element.addEventListener('click', (event) => {
        event.preventDefault();
        this.$lightbox([element.getAttribute('href')]);
        this.$lightbox.open(element.getAttribute('href'));
      });
    });
  },
}));
